import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeHero from "./sections/WelcomeHero";
import OurServices from "./sections/OurServices";
import StartAConsultation from "./sections/StartAConsultation";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <WelcomeHero />
      <OurServices />
      <StartAConsultation />
      <Footer />
    </div>;
}